import { Insight } from "konect-model";
import ApiService from "./api-service";
import { Settings } from "../view/Settings";
import insights from '../db/insights.json';

export default class InsightService {
    private static apiService: ApiService = ApiService.getInstance();

    static async getInsights() : Promise<Insight[]> {

        if (Settings.useOfflineMode) {
            return insights.map(insight => Object.assign(new Insight(), insight));
        }
        return await InsightService.apiService.get("/insights/all");
    }

}